import { Genre } from "../../../models/genre/Genre"
import { httpGet } from "../../../libs/http/httpGet"
import { GenreGetInputModel } from "./GetInputModel"

/** ジャンル一覧取得 */
export const getGenre = async (model: GenreGetInputModel) => {
  return httpGet<Genre[]>("/v1/genre", model)
}
